import { JsonDecoder } from 'ts.data.json';
import { EmailSettings, Firm, OrderExternalFirm } from './model';

export const emailSettings = JsonDecoder.object<EmailSettings>(
    {
        disclosureEnabled: JsonDecoder.optional(JsonDecoder.boolean),
        disclosureMessage: JsonDecoder.optional(JsonDecoder.string)
    },
    'emailSettings'
);

export const orderExternalFirmDecoder = JsonDecoder.object<OrderExternalFirm>(
    {
        id: JsonDecoder.number,
        name: JsonDecoder.string,
        type: JsonDecoder.optional(JsonDecoder.string),
        crdNumber: JsonDecoder.optional(JsonDecoder.string)
    },
    'OrderExternalFirm'
);

// Firm
export const firmDecoder = JsonDecoder.object<Firm>(
    {
        id: JsonDecoder.string,
        name: JsonDecoder.optional(JsonDecoder.string),
        companyName: JsonDecoder.optional(JsonDecoder.string),
        externalFirm: JsonDecoder.optional(orderExternalFirmDecoder),
        addressLine1: JsonDecoder.optional(JsonDecoder.string),
        addressLine2: JsonDecoder.optional(JsonDecoder.string),
        city: JsonDecoder.optional(JsonDecoder.string),
        state: JsonDecoder.optional(JsonDecoder.string),
        zip: JsonDecoder.optional(JsonDecoder.string),
        phone1: JsonDecoder.optional(JsonDecoder.string),
        phone2: JsonDecoder.optional(JsonDecoder.string),
        firmType: JsonDecoder.optional(JsonDecoder.string),
        aiiFirmId: JsonDecoder.optional(JsonDecoder.string),
        crdnNumber: JsonDecoder.optional(JsonDecoder.string),
        emailSettings: JsonDecoder.optional(emailSettings)
    },
    'Firm'
);
